import { Pipe, PipeTransform } from '@angular/core';
import { ComparatorService } from '../../services/comparator-service';
import { RootBelastungVm } from '../../../core/services/grundpfandrecht-viewmodel.service';

@Pipe({
  name: 'orderByPfandrechtBelastung'
})
export class OrderByPfandrechtBelastungPipe implements PipeTransform {
  public constructor(private comperatorService: ComparatorService) {}

  transform(array: Array<RootBelastungVm>, ascending = true): Array<RootBelastungVm> {
    if (!array) {
      return array;
    }
    if (ascending) {
      return Array.from(array).sort((item1: RootBelastungVm, item2: RootBelastungVm) => {
        return this.comperatorService.pfandrechtBelastungComparator(item1, item2);
      });
    } else {
      return Array.from(array).sort((item1: RootBelastungVm, item2: RootBelastungVm) => {
        return this.comperatorService.pfandrechtBelastungComparator(item2, item1);
      });
    }
  }
}
